/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Page_HintInputs */

const cs_lustrace_page_hint = /** @type {(inputs: Lustrace_Page_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrola ARES, RÚIAN, katastru (KN), ISIR, CEE a stažení plného výpisu LV. Některé služby spotřebují kredity.`)
};

const en_lustrace_page_hint = /** @type {(inputs: Lustrace_Page_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check ARES, RÚIAN, cadastre (KN), ISIR, CEE, and download a full LV extract. Some services consume credits.`)
};

/**
* | output |
* | --- |
* | "Check ARES, RÚIAN, cadastre (KN), ISIR, CEE, and download a full LV extract. Some services consume credits." |
*
* @param {Lustrace_Page_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_page_hint = /** @type {((inputs?: Lustrace_Page_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Page_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_page_hint(inputs)
	return cs_lustrace_page_hint(inputs)
});